import { useState } from 'react'
import { Slider, Container, Value } from './style'

interface SliderProps {
  min?: string
  max?: string
  getStep?: any
  defaultValue?: number
}
export default function ({
  getStep,
  min = '0',
  max = '100',
  defaultValue = 50,
}: SliderProps) {
  const [step, setStep] = useState(String(defaultValue))
  return (
    <Container>
      <Value rate={step}>{`${step}%`}</Value>
      <Slider
        value={step}
        type="range"
        id="opacity"
        name="opacity"
        min={min}
        max={max}
        onClick={(e: any) =>
          getStep(e.target.value) && console.log('step', step)
        }
        onChange={(e: any) => setStep(e.target.value)}
        /*
        onChange={(e) => {
          getStep(e.target.value)
          setStep(e.target.value)
        }}
        */
        onMouseDown={(e: any) => console.log(`clicando: ${e.target.value}`)}
        rate={step}
      />
    </Container>
  )
}
